import { useDatabase } from "@nozbe/watermelondb/hooks";
import React from "react";
import { TextPropTypes, Text } from "@towersystems/roam-common-native";
import Location from "../../utilities/data/model/Location";

const UNKNOWN_LOCATION = "Unknown Location";

export type LocationIdToNameProps = TextPropTypes & {
  locationId: string;
};

export const LocationIdToName = ({
  locationId,
  ...props
}: LocationIdToNameProps) => {
  const [name, setName] = React.useState<string | undefined>(undefined);
  const database = useDatabase();

  React.useEffect(() => {
    (async () => {
      try {
        const location = await database
          .get<Location>("locations")
          .find(locationId);

        setName(location.name ?? UNKNOWN_LOCATION);
      } catch (err) {
        setName(UNKNOWN_LOCATION);
      }
    })();
  }, [locationId]);

  if (!name) {
    return null;
  }

  return <Text {...props}>{name}</Text>;
};
